<template>
    <div class="map-view-container">
        <!--        <button class="icon-button"><span class="taxi-centerd-pin"></span></button>-->


        <div v-if="tripSummary" class="trip-summary">
            <div class="summary-icon">
                <span class="taxi-check"></span>
            </div>

            <div class="summary-text">მგზავრობა დასრულებულია</div>

            <div class="summary-entry">
                <span class="summary-entry-value">{{tripSummary.distance}}</span>
                <span class="summary-entry-unit">კმ</span>
            </div>

            <div class="summary-entry">
                <span class="summary-entry-value">{{tripSummary.fullPrice}}</span>
                <span class="summary-entry-unit taxi-lari"></span>
            </div>

            <button @click="closeTripSummary" class="button">დახურვა</button>
        </div>



        <div v-if="tripData" class="trip-data">
            <div class="trip-data-entry">
                <span class="trip-data-value">{{tripData.distance}}</span>
                <span class="trip-data-unit">კმ</span>
            </div>

            <div class="trip-data-entry">
                <span class="trip-data-value">{{tripData.fullPrice}}</span>
                <span class="trip-data-unit taxi-lari"></span>
            </div>
        </div>

        <div v-if="tripRules.length" class="rule-list">
            <div class="rule-list-header">
                აირჩიეთ კლიენტი <span @click="closeRuleList" class="taxi-close"></span>
            </div>
            <div class="rule-list-body">
                <div v-for="rule in tripRules" class="rule-list-entry">
                    <label class="radio-container">{{ rule.ruleName }}
                        <input type="radio" :value="rule.id" v-model="tripRuleId" name="ruleEntry">
                        <div class="checkmark"></div>
                    </label>
                </div>
            </div>
        </div>

        <div v-if="!tripSummary" class="action-button">
            <loading v-if="loading.authCode" :width="30"/>
            <template v-else>
                <button v-if="!tripRuleId && !tripData" @click="getTripRules" :class="{disabled: tripRules.length}" class="button">
                    მგზავრის აყვანა
                </button>

                <button v-if="tripRuleId && !tripData" @click="createTrip" class="button">
                    მგზავრობის დაწყება
                </button>

                <button v-if="tripData" @click="finishTrip" class="button">
                    მგზავრობის დასრულება
                </button>
            </template>
        </div>

        <map-wrapper/>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import {GET_POSITION_DATA, CLEAR_POSITION_LOADER_TIMEOUT} from "../store/types";
    import MapWrapper from "../components/MapWrapper";
    export default {
        data() {
            return {
                loading: false,
                tripRules: [],
                tripRuleId: null,
                tripSummary: null
            }
        },
        methods:{
            getTripRules(){
                this.loading = true;
                let requestData = {
                    url: 'api/taxi/driver/trip-rule/list',
                    method: 'GET',
                };

                this.$apiService.sendRequest(requestData).then(resp => {
                    this.tripRules = resp.data.data;
                }).catch(error => {
                    this.$eventBus.$emit('showAlert', {
                        content: error.response ? error.response.data.errorMessages.join("\r\n") : error.message,
                        config: {type: 'error'}
                    });
                }).finally(()=>{
                    this.loading = false;
                });
            },

            createTrip(){
                this.loading = true;
                let requestData = {
                    url: 'api/taxi/driver/trip/create',
                    method: 'POST',
                    data:{tripRuleId: this.tripRuleId}
                };

                this.$apiService.sendRequest(requestData).then(resp => {
                    this.$store.commit(CLEAR_POSITION_LOADER_TIMEOUT);
                    this.getPositionData();
                    this.closeRuleList();
                }).catch(error => {
                    this.$eventBus.$emit('showAlert', {
                        content: error.response ? error.response.data.errorMessages.join("\r\n") : error.message,
                        config: {type: 'error'}
                    });
                }).finally(()=>{
                    this.loading = false;
                });
            },

            finishTrip(){
                this.loading = true;
                let requestData = {
                    url: 'api/taxi/driver/trip/finish',
                    method: 'POST'
                };

                this.$apiService.sendRequest(requestData).then(resp => {
                    this.$store.commit(CLEAR_POSITION_LOADER_TIMEOUT);
                    this.getPositionData();

                    this.tripSummary = {
                        distance: resp.data.data.distance,
                        fullPrice: resp.data.data.fullPrice
                    }

                }).catch(error => {
                    this.$eventBus.$emit('showAlert', {
                        content: error.response ? error.response.data.errorMessages.join("\r\n") : error.message,
                        config: {type: 'error'}
                    });
                }).finally(()=>{
                    this.loading = false;
                });
            },

            getPositionData(){
                this.$store.dispatch(GET_POSITION_DATA);
            },

            closeTripSummary(){
                this.tripSummary = null;
            },

            closeRuleList(){
                this.tripRules = [];
                this.tripRuleId = null;
            },
        },
        computed:{
            ...mapGetters(['isAuthenticated', 'tripData']),
        },
        components: {
            MapWrapper
        },
        created() {
            this.getPositionData();
            if(!this.isAuthenticated) this.$router.push({name: 'authorization'});
        }
    }
</script>

<style lang="scss" scoped>
    .map-view-container {
        position: relative;
        flex: 1;

        .trip-summary {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translateY(-50%) translateX(-50%);
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            width: 80%;
            z-index: 9991;
            padding: 40px 20px;
            background-color: $white;
            border-radius: $border-radius;
            box-shadow: $box-shadow;

            .summary-icon {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 60px;
                height: 60px;
                border-radius: 50%;
                border: 2px solid $primary-color;
                color: $primary-color;
                font-size: 1.8rem;

                span {
                    margin-top: 5px;
                }
            }

            .summary-text {
                margin-top: 30px;
                margin-bottom: 30px;
                font-weight: bold;
                color: $secondary-color;
            }

            .summary-entry{
                display: flex;
                justify-content: center;
                align-items: center;

                .summary-entry-value{
                    font-family: dejavu_sansbold;
                    font-size: 1.6rem;
                    color: $secondary-color;
                }

                .summary-entry-unit{
                    margin-left: 8px;
                    color: $gray-7;
                }
            }

            .button{
                margin-top: 40px;
                padding-left: 40px;
                padding-right: 40px;
            }
        }

        .trip-data{
            position: absolute;
            top: 20px;
            left: 50%;
            transform: translateX(-50%);
            display: flex;
            justify-content: space-between;
            width: 90%;
            z-index: 9991;

            .trip-data-entry{
                display: flex;
                justify-content: center;
                align-items: center;
                background-color: $white;
                padding-left: 20px;
                padding-right: 20px;
                height: 44px;
                border-radius: 22px;
                box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.15);;

                .trip-data-value{
                    font-family: dejavu_sansbold;
                    font-size: 1.4rem;
                    color: $secondary-color;
                }

                .trip-data-unit{
                    margin-left: 8px;
                    font-size: .95rem;
                    color: $gray-5;
                }
            }
        }

        .rule-list{
            position: absolute;
            top: 30%;
            left: 50%;
            transform: translateY(-30%) translateX(-50%);
            width: 80%;
            height: 60%;
            z-index: 9991;
            background-color: $white;
            border-radius: $border-radius;
            box-shadow: $box-shadow;

            .rule-list-header {
                display: flex;
                justify-content: space-between;
                align-items: center;
                height: 42px;
                padding: 10px 15px;
                font-size: .85rem;
                color: $gray-5;
                span{
                    font-size: 1.4rem;
                    color: $secondary-color;
                }
            }
            .rule-list-body{
                height: calc(100% - 40px);
                overflow-y: auto;

                .rule-list-entry {
                    padding: 15px;
                    border-top: 1px solid $gray-2;
                    font-size: .95rem;
                }
            }
        }

        .action-button{
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            bottom: 40px;
            z-index: 999;
            width: 70%;

            .button{
                width: 100%;
            }
        }

        .icon-button {
            position: absolute;
            right: 20px;
            bottom: 90px;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 44px;
            height: 44px;
            border-radius: 50%;
            border: none;
            background-color: $secondary-color;
            color: $white;
            font-size: 1.4rem;
            z-index: 999;
        }
    }
</style>